export default "__VITE_ASSET__CLKnaCva__"